import { render, staticRenderFns } from "./custom-table.vue?vue&type=template&id=58a23342"
import script from "./custom-table.vue?vue&type=script&lang=js"
export * from "./custom-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports